// @ts-nocheck
import { call, put, takeLatest } from 'redux-saga/effects';
// import {router} from 'components/routes/Router';
import { postFormData } from 'utils/apiHelper';
import { API_URL as API_URI } from 'config/constants';
import { Types } from '../actions/estimation_sheet_import';

function* saveEstimationDataRequest(action) {
  try {
    const { payload } = action;
    const token = localStorage.getItem('token');
    const data = yield call(
      postFormData,
      `${API_URI}/organisation/parse_sheet/`,
      'post',
      payload,
      token,
    );

    if (data) {
      yield put({ type: Types.SAVE_ESTIMATION_DATA_SUCCESS, payload: data });
      // router.navigate('/login');
    }
  } catch (error) {
    yield put({ type: Types.SAVE_ESTIMATION_DATA_FAILURE, payload: error });
  }
}

function* estimationSheetWatcher() {
  yield takeLatest(
    Types.SAVE_ESTIMATION_DATA_REQUEST,
    saveEstimationDataRequest,
  );
}

export default estimationSheetWatcher;
